import { createContext } from 'react-router-dom';

export const globalRouteContext = createContext<{ channel: number | null }>({ channel: null });
